import { useEffect, useState } from 'react';

export const useMobileScreen = () => {
  const [isMobileScreen, setIsMobileScreen] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');

    const handleResize = (e: MediaQueryListEvent | MediaQueryList) => {
      setIsMobileScreen(e.matches);
    };

    if (mediaQuery) {
      handleResize(mediaQuery);

      mediaQuery.addEventListener('change', handleResize);
    }

    return () => {
      mediaQuery?.removeEventListener('change', handleResize);
    };
  }, []);

  return { isMobileScreen };
};
